
import Vue from 'vue';
import Add24 from '@carbon/icons-vue/es/add/24';
import TrashCan24 from '@carbon/icons-vue/es/trash-can/16';
import IconTextButton from '../Buttons/IconTextButton.vue';

export default Vue.extend({
  name: 'ActionsPanel',
  components: {
    IconTextButton,
  },
  props: {
    deleteDisabled: Boolean,
  },
  data() {
    return {
      Add24: Add24,
      TrashCan24: TrashCan24,
    };
  },
});
